import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LoadingSymbolModule } from 'Angular/features/components/loaders/loading-symbol/loading-symbol.module';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { BaseAutocompleteModule } from 'SearchApp/ts/features/base-autocomplete/base-autocomplete.module';

import { SingleInfoFieldSelectorModalComponent } from './single-info-field-selector-modal/single-info-field-selector-modal.component';
import { MultiInfoFieldSelectorModalComponent } from 'SecuritiesApp/ts/info-field-selector-modals/multi-info-field-selector-modal/multi-info-field-selector-modal.component';
import { InfoFieldListComponent } from 'SecuritiesApp/ts/info-field-selector-modals/shared/info-field-list/info-field-list.component';

@NgModule({
    imports: [
        BaseAutocompleteModule,
        CommonModule,
        IconModule,
        LoadingSymbolModule,
        ModalBaseModule,
        FeatureNeededModule,
    ],
    declarations: [InfoFieldListComponent, SingleInfoFieldSelectorModalComponent, MultiInfoFieldSelectorModalComponent],
    exports: [SingleInfoFieldSelectorModalComponent, MultiInfoFieldSelectorModalComponent],
})
export class InfoFieldSelectorModalModule {}
